var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{staticClass:"radio__input",attrs:{"type":"radio","id":_vm.label,"name":_vm.groupName},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('choiceChange', _vm.value)}}}),_c('label',{staticClass:"radio__label",attrs:{"for":_vm.label}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }